export async function fetchCsrfToken(): Promise<string> {
  const res = await fetch('/csrf_token', { credentials: 'include' })
  const data = await res.json()
  return data.token
}